module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点位名称"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "collapse-tags": ""
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.name,
        "value": item.mnCode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('my-button', {
    attrs: {
      "QueryButtonShow": "",
      "ResetButtonShow": ""
    },
    on: {
      "select-type": _vm.clickBtn
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataDayList,
      "border": "",
      "highlight-current-row": "",
      "max-height": _vm.formHeight,
      "size": "small"
    },
    on: {
      "selection-change": _vm.selsChangeDay
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "projectName",
      "label": "项目名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "siteName",
      "label": "点位名称",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ld",
      "label": "Ld(dB)",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ln",
      "label": "Ln(dB)",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ldn",
      "label": "Ldn(dB)",
      "sortable": ""
    }
  }), _vm._v(" "), _vm._l((_vm.reviewWays), function(item) {
    return _c('el-table-column', {
      key: item.keyword,
      attrs: {
        "prop": item.keyword,
        "label": item.name
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.keyword == 'preReview') ? _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', [_c('el-button', {
            attrs: {
              "type": "info",
              "size": "small",
              "disabled": ""
            }
          }, [_vm._v("未标记")])], 1) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            on: {
              "click": function($event) {
                return _vm.showStatus(scope.$index, scope.row, item.keyword, '通过', '标记')
              }
            }
          }, [_c('el-button', {
            attrs: {
              "type": "success",
              "size": "small"
            }
          }, [_vm._v("通过")])], 1) : _c('span', {
            on: {
              "click": function($event) {
                return _vm.showStatus(scope.$index, scope.row, item.keyword, '异常', '标记')
              }
            }
          }, [_c('el-button', {
            attrs: {
              "type": "danger",
              "size": "small"
            }
          }, [_vm._v("异常")])], 1)]) : _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', [_c('el-button', {
            attrs: {
              "type": "info",
              "size": "small",
              "disabled": ""
            }
          }, [_vm._v("未审核")])], 1) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            on: {
              "click": function($event) {
                return _vm.showStatus(scope.$index, scope.row, item.keyword, '通过', '审核')
              }
            }
          }, [_c('el-button', {
            attrs: {
              "type": "success",
              "size": "small"
            }
          }, [_vm._v("通过")])], 1) : _c('span', {
            on: {
              "click": function($event) {
                return _vm.showStatus(scope.$index, scope.row, item.keyword, '无效', '审核')
              }
            }
          }, [_c('el-button', {
            attrs: {
              "type": "danger",
              "size": "small"
            }
          }, [_vm._v("无效")])], 1)])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.reviewData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("审核数据")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.queryReviewRecordDay(scope.$index, scope.row)
            }
          }
        }, [_vm._v("审核记录")])]
      }
    }])
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.selsDay.length === 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reviewDataOut.apply(null, arguments)
      }
    }
  }, [_vm._v("数据审核")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dayPreviewCon + '状态',
      "visible": _vm.statusVisible,
      "width": "20%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.statusVisible = $event
      }
    }
  }, [_c('p', [_vm._v("设备名称：" + _vm._s(_vm.statusRow.siteName))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dayPreviewCon) + "时间：" + _vm._s(_vm.statusRow.statustime))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dayPreviewCon) + "状态：" + _vm._s(_vm.statusRow.status))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.dayPreviewCon) + "人员：" + _vm._s(_vm.statusRow.userName))]), _vm._v(" "), _c('p', [_vm._v("标注信息：" + _vm._s(_vm.statusRow.remark))])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核数据",
      "visible": _vm.reviewVisible,
      "append-to-body": true,
      "width": "80%",
      "top": "5vh",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.reviewVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "yenr_top"
  }, [_c('div', {
    staticClass: "juednm_1"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ar"
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v(" 站点：  "), _c('span', [_vm._v(_vm._s(_vm.dayRow.siteName) + "-" + _vm._s(_vm.dayRow.functionalAreaName) + " ")])]), _vm._v(" "), _c('div', [_vm._v(" 站点编号：" + _vm._s(_vm.dayRow.mn) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "hour"
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("日期")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dayRow.time) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "hour"
  }, [_c('div', {
    staticClass: "bt"
  }, [_vm._v("有效小时")]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(_vm.dayRow.total) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "uend_2"
  }, [_c('div', {
    staticClass: "neds_name"
  }, [_vm._v("Ld(dB)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dayRow.ld))])]), _vm._v(" "), _c('div', {
    staticClass: "uend_2"
  }, [_c('div', {
    staticClass: "neds_name"
  }, [_vm._v("Ln(dB)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dayRow.ln))])]), _vm._v(" "), _c('div', {
    staticClass: "uend_2"
  }, [_c('div', {
    staticClass: "neds_name"
  }, [_vm._v("Ldn(dB)")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.dayRow.ldn))])])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataHourList,
      "border": "",
      "highlight-current-row": "",
      "max-height": _vm.formHeight * 0.8,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsChangeHour
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "hour",
      "label": "小时"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isValid",
      "label": "审核状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isValid == 0) ? _c('span', {
          staticStyle: {
            "color": "#3e6eff"
          }
        }, [_vm._v(" 未审核")]) : (scope.row.isValid == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("通过 ")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("无效 ")])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.reviewWays), function(item) {
    return _c('el-table-column', {
      key: item.keyword,
      attrs: {
        "prop": item.keyword,
        "label": item.name
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.keyword == 'preReview') ? _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', {
            staticStyle: {
              "color": "#3e6eff"
            }
          }, [_vm._v("未标记")]) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            staticStyle: {
              "color": "green"
            }
          }, [_vm._v("通过")]) : _c('span', {
            staticStyle: {
              "color": "red"
            }
          }, [_vm._v("异常")])]) : _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', {
            staticStyle: {
              "color": "#3e6eff"
            }
          }, [_vm._v("未审核")]) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            staticStyle: {
              "color": "green"
            }
          }, [_vm._v("通过")]) : _c('span', {
            staticStyle: {
              "color": "red"
            }
          }, [_vm._v("无效")])])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "minuteCount",
      "label": "分钟数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isMinuteValid == 'valid') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(_vm._s(scope.row.minuteCount) + " ")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(scope.row.minuteCount) + " ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.queryMinuteData(scope.$index, scope.row)
            }
          }
        }, [_vm._v("分钟数据")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.queryReviewRecordHour(scope.$index, scope.row)
            }
          }
        }, [_vm._v("审核记录")])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.facHourList), function(item) {
    return _c('el-table-column', {
      key: item.keyWord,
      attrs: {
        "prop": item.keyWord,
        "label": item.name,
        "min-width": item.name.length > 7 ? '120p' : ''
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row[item.keyWord + '_color'] != '-') ? _c('span', {
            style: ('color:' + scope.row[item.keyWord + '_color'])
          }, [_vm._v(_vm._s(scope.row[item.keyWord + "_data"]))]) : _c('span', {
            staticStyle: {
              "color": "#000"
            }
          }, [_vm._v(_vm._s(scope.row[item.keyWord + "_data"]))])]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deviceEvent.apply(null, arguments)
      }
    }
  }, [_vm._v("设备事件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getExamineHourList(_vm.dayRow)
      }
    }
  }, [_vm._v("数据刷新")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reviewDataChild('day')
      }
    }
  }, [_vm._v("天数据审核")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.selsHour.length === 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reviewDataChild('hour')
      }
    }
  }, [_vm._v("小时数据审核")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleReview.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.recordTitle,
      "visible": _vm.dialogRecordVisible,
      "append-to-body": true,
      "width": "80%",
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogRecordVisible = $event
      }
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataRecordList,
      "border": "",
      "highlight-current-row": "",
      "size": "mini"
    }
  }, [_c('el-table-column', {
    key: "index",
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), (_vm.recordType == 'day') ? _c('el-table-column', {
    key: "siteName",
    attrs: {
      "prop": "siteName",
      "label": "点位名称"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    key: "dataTime",
    attrs: {
      "prop": "dataTime",
      "label": "数据时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "status",
    attrs: {
      "prop": "status",
      "label": "审核状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 1 || scope.row.status == '1') ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v(" 通过 ")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("无效 ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "userName",
    attrs: {
      "prop": "userName",
      "label": "审核人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    key: "time",
    attrs: {
      "prop": "time",
      "label": "审核时间"
    }
  }), _vm._v(" "), (_vm.recordType == 'hour' || _vm.recordType == 'minute') ? _c('el-table-column', {
    key: "reasonStr",
    attrs: {
      "prop": "reasonStr",
      "label": "原因"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    key: "remark",
    attrs: {
      "prop": "remark",
      "label": "标注信息"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.remark == '') ? _c('span') : _c('span', [_c('el-popover', {
          attrs: {
            "placement": "bottom",
            "title": "标注信息",
            "width": "200",
            "trigger": "click",
            "content": scope.row.remark
          }
        }, [_c('el-button', {
          attrs: {
            "slot": "reference",
            "icon": "el-icon-search",
            "circle": "",
            "size": "small"
          },
          slot: "reference"
        })], 1)], 1)]
      }
    }])
  }), _vm._v(" "), (_vm.recordType == 'day') ? _c('el-table-column', {
    key: "imgUrl",
    attrs: {
      "prop": "imgUrl",
      "label": "佐证资料"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.imgUrl == '' || scope.row.imgUrl == undefined) ? _c('span') : _c('span', [_c('el-image', {
          staticStyle: {
            "width": "30px",
            "height": "16px"
          },
          attrs: {
            "src": "/static/query.png",
            "preview-src-list": scope.row.srcList
          }
        })], 1)]
      }
    }], null, false, 2125100790)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "分钟数据",
      "visible": _vm.dialogMinuteVisible,
      "append-to-body": true,
      "width": "80%",
      "top": "5vh",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogMinuteVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.minuteDataList,
      "border": "",
      "highlight-current-row": "",
      "max-height": _vm.formHeight * 0.8,
      "size": "mini"
    },
    on: {
      "selection-change": _vm.selsChangeMinute
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "数据时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isValid",
      "label": "审核状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.isValid == 0) ? _c('span', {
          staticStyle: {
            "color": "#3e6eff"
          }
        }, [_vm._v(" 未审核")]) : (scope.row.isValid == 1) ? _c('span', {
          staticStyle: {
            "color": "green"
          }
        }, [_vm._v("通过 ")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("无效 ")])]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.reviewWays), function(item) {
    return _c('el-table-column', {
      key: item.keyword,
      attrs: {
        "prop": item.keyword,
        "label": item.name
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.keyword == 'preReview') ? _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', {
            staticStyle: {
              "color": "#3e6eff"
            }
          }, [_vm._v("未标记")]) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            staticStyle: {
              "color": "green"
            }
          }, [_vm._v("通过")]) : _c('span', {
            staticStyle: {
              "color": "red"
            }
          }, [_vm._v("异常")])]) : _c('span', [(scope.row[item.keyword + 'Status'] == 0) ? _c('span', {
            staticStyle: {
              "color": "#3e6eff"
            }
          }, [_vm._v("未审核")]) : (scope.row[item.keyword + 'Status'] == 1) ? _c('span', {
            staticStyle: {
              "color": "green"
            }
          }, [_vm._v("通过")]) : _c('span', {
            staticStyle: {
              "color": "red"
            }
          }, [_vm._v("无效")])])]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "是否校准"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.cal == '1') ? _c('span', {
          staticStyle: {
            "color": "red",
            "cursor": "pointer"
          }
        }, [_vm._v("是")]) : _c('span', [_vm._v("否")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "280"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.showReviewMinute(scope.$index, scope.row)
            }
          }
        }, [_vm._v("数据审核")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.queryReviewRecordMinute(scope.$index, scope.row)
            }
          }
        }, [_vm._v("审核记录")]), _vm._v(" "), (scope.row.recordings != '-') ? _c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "icon": "el-icon-view"
          },
          on: {
            "click": function($event) {
              return _vm.queryRecord(scope.$index, scope.row)
            }
          }
        }, [_vm._v("查看录音")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _vm._l((_vm.facHourList), function(item) {
    return _c('el-table-column', {
      key: item.keyWord,
      attrs: {
        "prop": item.keyWord,
        "label": item.name,
        "min-width": item.name.length > 7 ? '120p' : ''
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row[item.keyWord + '_color'] != '-') ? _c('span', {
            style: ('color:' + scope.row[item.keyWord + '_color'])
          }, [_vm._v(_vm._s(scope.row[item.keyWord + "_data"]))]) : _c('span', {
            staticStyle: {
              "color": "#000"
            }
          }, [_vm._v(_vm._s(scope.row[item.keyWord + "_data"]))])]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": this.selsMinute.length === 0
    },
    nativeOn: {
      "click": function($event) {
        return _vm.showReviewMinute.apply(null, arguments)
      }
    }
  }, [_vm._v("数据审核")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleMinuteReview.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.SetRecordTitle,
      "visible": _vm.dialogSetRecordVisible,
      "append-to-body": true,
      "width": "60%",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogSetRecordVisible = $event
      }
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.reviewlistLoading),
      expression: "reviewlistLoading"
    }],
    ref: "formSetRecord",
    attrs: {
      "model": _vm.formSetRecord,
      "label-width": "80px",
      "rules": _vm.recordType == 'day' ? _vm.validDayRules : _vm.validHourRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.formSetRecord.status),
      callback: function($$v) {
        _vm.$set(_vm.formSetRecord, "status", $$v)
      },
      expression: "formSetRecord.status"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "通过",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无效",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), (_vm.recordType == 'hour' || _vm.recordType == 'minute') ? _c('el-form-item', {
    attrs: {
      "label": "选择原因",
      "prop": "reasonId"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择原因",
      "filterable": ""
    },
    model: {
      value: (_vm.formSetRecord.reasonId),
      callback: function($$v) {
        _vm.$set(_vm.formSetRecord, "reasonId", $$v)
      },
      expression: "formSetRecord.reasonId"
    }
  }, _vm._l((_vm.reasonList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标注信息",
      "prop": "remark"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formSetRecord.remark),
      callback: function($$v) {
        _vm.$set(_vm.formSetRecord, "remark", $$v)
      },
      expression: "formSetRecord.remark"
    }
  })], 1), _vm._v(" "), (_vm.recordType == 'day') ? _c('el-form-item', {
    attrs: {
      "label": "佐证材料",
      "prop": "img"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "http-request": _vm.httpRequest,
      "name": "file",
      "on-change": _vm.change,
      "accept": "image/*",
      "file-list": _vm.fileListShow,
      "on-remove": _vm.remove,
      "list-type": "picture",
      "multiple": "",
      "auto-upload": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传图片文件，且最好不超过500kb")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSetRecordSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reviewDataChildSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "设备事件详情",
      "visible": _vm.dialogEventVisible,
      "append-to-body": true,
      "width": "60%",
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEventVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.eventList,
      "border": "",
      "highlight-current-row": "",
      "max-height": _vm.formHeight * 0.8,
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "偏差/事件"
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "详情",
      "visible": _vm.noiseRecordVisible,
      "close-on-click-modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.noiseRecordVisible = $event
      }
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.noiseRecordList,
      "border": "",
      "highlight-current-row": "",
      "max-height": _vm.formHeight,
      "size": "small"
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noisesource",
      "label": "声源识别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.noisesource == null || scope.row.noisesource == '') ? _c('span', [_vm._v("待识别")]) : _c('span', [_vm._v(_vm._s(scope.row.noisesource))])]
      }
    }])
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-7a9d2630"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/review/ReviewData.vue
// module id = 1948
// module chunks = 1